import React, { Component } from "react";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import {revisionReportsInitNav} from "../../store/config";

export default class RevisionReportsSubnav extends Component {
	render() {
		let { params } = this.props;
		let currentStep = _.find(revisionReportsInitNav, {step: _.toInteger(this.props.step)});
		return <div className="subnavigation-projects">
			<div className="level">
				<div className="level-item subnav-section">
					<div className="details">
						<h5>{currentStep ? currentStep.title : ''} - {this.props.agency ? this.props.agency : ''}</h5>
						<h6>{params.modality === 'modalidad-i' ? 'Modalidad I' : (params.modality === 'modalidad-ii' ? 'Modalidad II' : 'Modalidad III')}</h6>
					</div>
				</div>
				<div className="level-item subnav-step">
					<div className="details">
						{revisionReportsInitNav ?
							<div className="level context-navigation">
								{revisionReportsInitNav.map((item, k) => {
									let projectLink = _.replace(_.replace(_.replace(_.replace(item.url, ':modality', params.modality), ':state?', params.state === 'undefined' ? params.municipalities[0].state.short : params.state), ':municipality?', params.municipality === null ? params.municipalities[0].slug : params.municipality), 'undefined', '');

									return (
										<div className="level-item" key={k}>
											<NavLink className="step" to={projectLink} activeClassName="active">
												<p>{item.step}</p>
												<span>{item.title}</span>
											</NavLink>
										</div>
									)
								})}
							</div> : ''}
					</div>
				</div>
			</div>
		</div>
	}
}


// WEBPACK FOOTER //
// ./src/elements/navigation/revision_reports_subnav.jsx